module.exports = __webpack_public_path__ + "static/media/adobe.6984f2f5.svg";